import KondoHeader from "../Header";
import KondoFooter from "../Footer";
import ContactButton from "../ContactButton";
import Pankuzu from "../pankuzu";

import CompanyTop from "../../images/CompanyTop.png";
import Mapimg from "../../images/MapImg.png";

// animation
import { motion } from "framer-motion";

const PageCompany = () => {
  return (
    <div id="PageKondou">
      <div id="PageCompany">
        <KondoHeader />
        <motion.div
          animate={{
            y: 0,
            opacity: 1,
          }}
          initial={{
            y: 0,
            opacity: 1,
          }}
          exit={{
            y: 100,
            opacity: 0,
          }}
          transition={{
            duration: 0.4,
            ease: "easeOut",
          }}
        >
          <main>
            <section className="company-top">
              <img src={CompanyTop} alt="会社ページのトップ" />
              <Pankuzu pagename="会社案内" />
              <article>
                <h1>GREETING</h1>
                <h2>ごあいさつ</h2>
                <p>
                  1890年（明治23年）に四国徳島より石狩郡新篠津村に入植。1898年（明治31年）旭川に移住し、1条通3丁目に近藤染舗を開業しました。この当時の写真は北海道の歴史を知る上で非常に貴重な資料とされています。
                  <br />
                  近藤染舗は当時から、袢天、のぼり、旗、のれん、帆前掛等を主に染めていました。
                  <br />
                  おかげ様で明治31年の創業以来、染一筋で現在まで営業しております。
                </p>
                <h3>代表取締役 阿部 安弘</h3>
              </article>
            </section>
            <section>
              <article className="company-overview">
                <h1>COMPANY</h1>
                <h2>会社概要</h2>
              </article>
              <table>
                <tr>
                  <th>会社名</th>
                  <td>株式会社　近藤染工場</td>
                </tr>
                <tr>
                  <th>代表取締役</th>
                  <td>阿部　安弘</td>
                </tr>
                <tr>
                  <th>創業年月</th>
                  <td>明治31年4月8日</td>
                </tr>
                <tr>
                  <th>資本金</th>
                  <td>1,000万円</td>
                </tr>
                <tr>
                  <th>代表取締役</th>
                  <td>阿部　安弘</td>
                </tr>
                <tr>
                  <th>本社所在地</th>
                  <td className="table-flex">
                    〒070-0031 北海道旭川市１条通３丁目右１
                    <button>アクセス</button>
                  </td>
                </tr>
                <tr className="table-address">
                  <th>連絡先</th>
                  <td>
                    <h4>【本社】</h4>
                    <span className="span-tel">TEL: 0166-22-2255</span>
                    <br />
                    <span className="span-fax">FAX: 0166-24-5406</span>
                  </td>
                </tr>
                <tr>
                  <th>営業品目</th>
                  <td className="table-sentence">
                    国旗・大漁旗・船名旗・軍艦旗・万国旗・会旗・社旗・校旗・組合旗・垂旗・安全旗・優勝旗
                    宣伝旗・神社のぼり・神社仙閣幕・祭りのぼり・祭りはんてん・帯・豆しぼり手拭・神棚幕
                    門幕・宣伝幕・宣伝のれん・売出しのぼり・懸垂幕・横断幕・紅白幕・腕章・たすき・ゼッケン
                    手拭・タオル・風呂敷・前掛・別誂のれん・別誂はんてん・その他名入れ染め
                  </td>
                </tr>
              </table>
            </section>
            <section className="company-map">
              <h1>ACCESS</h1>
              <h2>アクセス</h2>
              <address>
                <img src={Mapimg} alt="Google Map" />
                <h3>〒070-0031 北海道旭川市１条通３丁目右1号</h3>
              </address>
            </section>
          </main>
          <ContactButton />
          <KondoFooter />
        </motion.div>
      </div>
    </div>
  );
};
export default PageCompany;
